import { Card, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { FunctionComponent, useState } from 'react';
import { ArrowDownward, ArrowUpward, DeleteOutline, MoreHoriz } from '@mui/icons-material';
import Section from '../interfaces/Section';

interface MyContainerProps {
    id: number;
    className: string;
    section: Section;
    onMoveSection: any;
    length: number;
    onRemoveSection: any;
}

const MyContainer: FunctionComponent<MyContainerProps> = (props) => {

    const { id, length, onMoveSection, children, className, onRemoveSection } = props;

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleMove = (orderId: number, operand: number) => {
        onMoveSection(orderId, operand);
        handleClose();
    }

    const handleRemove = (id: number) => {
        onRemoveSection(id)
        handleClose();
    }

    return (
        <Card
            className={className}
            style={{
                display: 'flex',
                flexDirection: 'column',
                padding: 15,
                marginBottom: 15,
            }}
            draggable
        >
            <div style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'top',
                marginTop: -4,
                alignSelf: 'end',
            }}>
                <MoreHoriz
                    color='success'
                    aria-controls={open ? 'basic-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                    onClick={handleClick} />
            </div>
            {children}

            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                {
                    id !== 0 && <MenuItem onClick={() => handleMove(id, 1)}>
                        <ListItemIcon>
                            <ArrowUpward fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Move Up</ListItemText>
                    </MenuItem>
                }

                {
                    id !== length && <MenuItem onClick={() => handleMove(id, -1)}>
                        <ListItemIcon>
                            <ArrowDownward fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Move Down</ListItemText>
                    </MenuItem>
                }

                <MenuItem onClick={() => handleRemove(id)}>
                    <ListItemIcon>
                        <DeleteOutline fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Remove</ListItemText>
                </MenuItem>

            </Menu>

        </Card>
    );
}

export default MyContainer;